export default __webpack_public_path__ + "static/media/04_photo.24c8d384.jpeg";